export default {
    upload_image_title: "Insertar Imagen",
    upload_image_label: "Cargue una nueva imagen o elija una de las cargadas anteriormente",
    upload_image_insert: "Insertar",
    upload_image_size_exceeds: "El tamaño de la imagen supera los 10 mb",
    upload_image_drap_drop: "Arrastre y suelte alguna imagen aquí, o haga clic para seleccionar la imagen",
}